module.exports = __webpack_public_path__ + "static/media/img_2.10782ba1.JPG";